import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import {fromEvent, Subscription} from "rxjs";
import {delay, tap} from "rxjs/operators";

@Directive({
    selector: '[click-outside]',
    standalone: false
})

export class ClickedOutside implements OnInit, OnDestroy {

	private listening: boolean;
	private globalClick: Subscription;

	@Output('clickOutside') clickOutside: EventEmitter<ClickedOutsideEvent> = new EventEmitter<ClickedOutsideEvent>();

	constructor(private _elRef: ElementRef) {
	}

	ngOnInit() {
		this.globalClick = fromEvent(document, 'click')
			.pipe(delay(1), tap(() => this.listening = true))
			.subscribe(event => this.onGlobalClick(event as MouseEvent));
	}

	ngOnDestroy() {
		this.clickOutside.emit({
			target: null,
			outside: true
		});
		this.globalClick.unsubscribe();
	}

	onGlobalClick(event: MouseEvent) {
		if (event instanceof MouseEvent && this.listening === true) {
			if (this.isDescendant(this._elRef.nativeElement, event.target) === true) {
				this.clickOutside.emit({
					target: (event.target || null),
					outside: false
				});
			} else {
				this.clickOutside.emit({
					target: (event.target || null),
					outside: true
				});
			}
		}
	}

	isDescendant(parent, child) {
		let node = child;
		while (node !== null) {
			if (node === parent) {
				return true;
			} else {
				node = node.parentNode;
			}
		}
		return false;
	}
}
export interface ClickedOutsideEvent {
	target: EventTarget;
	outside: boolean;
}
